import {Focusable} from './focusable.interface';

export class SimpleSuggestion implements Focusable{

  value: string;

  focused = false;

  constructor(attr: { text }) {
    this.value = attr.text;
  }

  clearFocus() {
    this.focused = false;
  }

  focus() {
    this.focused = true;
  }


}
